import { StoreCreator, StoreEnhancer, Reducer, Store } from "redux";

import { RootState } from "../../store/types";
import http from "../../helpers/http";
import * as actions from "./actions";
import * as selectors from "./selectors";
import * as constants from "./constants";

const storage = window.localStorage;

const restore = (store: Store<RootState>) => {
  const token = storage.getItem(constants.LOGIN_TOKEN_STORAGE_KEY);

  if (token) {
    store.dispatch(actions.saveToken(token));
  }
};

const dump = (store: Store<RootState>) =>
  store.subscribe(() => {
    const state = store.getState();
    const token = selectors.token(state);

    if (token) {
      // Set token as Authorization header on all outgoing requests
      http.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      try {
        storage.setItem(constants.LOGIN_TOKEN_STORAGE_KEY, token);
      } catch (error) {
        // Cannot access Storage; problem with private browsing in Safari
      }
    }
  });

// Persists login state
const authEnhancer = (storeCreator: StoreCreator) => (
  reducer: Reducer<RootState>,
  initState: RootState,
  enhancer: StoreEnhancer<RootState>,
) => {
  const store = storeCreator(reducer, initState, enhancer);

  restore(store);
  dump(store);

  return store;
};

export default authEnhancer;



// WEBPACK FOOTER //
// ./src/routes/Auth/enhancer.ts